<template>
  <div class="quick-list" :style="{height}">
    <div class="quick-list-tabs" :style="{padding:paddingTop}">
      <slot name="cardTop"/>
    </div>
    <div class="quick-list-content">
      <slot name="cardconTent"/>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      type: String,
      // default:"100%"
    },
    paddingTop: {
      type: String,
      default: '0 12px',
    }
  },
  data() {
    return {};
  },

  computed: {},
  methods: {},
  created() {
  },
  mounted() {
  },
};
</script>
<style scoped lang="less">

/* 深色大屏场景：与患者详情/处方页统一的弱描边，避免浅色 #DBDBDB 反差刺眼 */
.quick-list {
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 10px;
  background: rgba(0, 0, 0, 0.1);

  .main-card {
    padding: 5px;
  }
}
.quick-list-content {
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 80px);
  /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;

  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #dddee2;
    border: 1px solid #ced0da;
    cursor: pointer;
  }

  &::-webkit-scrollbar {
    width: 0px
  }
}

.quick-list-tabs {
  box-sizing: border-box;
  //height: 38px;
  line-height: 38px;
}
</style>
